import { Component } from '@angular/core';

@Component({
  selector: 'app-logout-confirm-dialog',
  templateUrl: './logout-confirm-dialog.component.html',
  styleUrl: './logout-confirm-dialog.component.scss'
})
export class LogoutConfirmDialogComponent {

}
